import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const R4Main = lazy(() => import('../r4draft/R4Main'));
const R4LiveDraft = lazy(() => import('../r4draft/R4LiveDraft'));
const R4DraftDayBoc = lazy(() => import('../r4draft/R4DraftDayBoc'));
const R4DraftDayClub = lazy(() => import('../r4draft/R4DraftDayClub'));
const R4DraftDisplay = lazy(() => import('../r4draft/R4DraftDisplay'));
const R4Connectivity = lazy(() => import('../r4draft/R4Connectivity'));
const R4DraftTestPicker = lazy(() => import('../r4draft/R4DraftTestPicker'));

export default [
  {
    id: NavConfig.groupConfigs.RULE_4.id,
    path: NavConfig.groupConfigs.RULE_4.to,
    element: (
      <R4Main>
        <Suspense>
          <Outlet />
        </Suspense>
      </R4Main>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.R4_PRE_DRAFT.to} />,
      },
      {
        id: NavConfig.linkConfigs.R4_DRAFT_LIVE.id,
        path: NavConfig.linkConfigs.R4_DRAFT_LIVE.to,
        element: (
          <R4LiveDraft>
            <Suspense>
              <Outlet />
            </Suspense>
          </R4LiveDraft>
        ),
        children: [
          {
            id: NavConfig.linkConfigs.R4_DRAFT_DAY_BOC_REACT.id,
            path: NavConfig.linkConfigs.R4_DRAFT_DAY_BOC_REACT.to,
            element: <R4DraftDayBoc />,
          },
          {
            id: NavConfig.linkConfigs.R4_DRAFT_DISPLAY_REACT.id,
            path: NavConfig.linkConfigs.R4_DRAFT_DISPLAY_REACT.to,
            element: <R4DraftDisplay />,
          },
          {
            id: NavConfig.linkConfigs.R4_DRAFT_DAY_CLUB_REACT.id,
            path: NavConfig.linkConfigs.R4_DRAFT_DAY_CLUB_REACT.to,
            element: <R4DraftDayClub />,
          },
          {
            id: NavConfig.linkConfigs.R4_CONNECTIVITY_REACT.id,
            path: NavConfig.linkConfigs.R4_CONNECTIVITY_REACT.to,
            element: <R4Connectivity />,
          },
          {
            id: NavConfig.linkConfigs.R4_DRAFT_TEST_PICKER.id,
            path: NavConfig.linkConfigs.R4_DRAFT_TEST_PICKER.to,
            element: <R4DraftTestPicker />,
          },
        ],
      },
    ],
  },
];
